import{REQUEST_PRODUCT_RELATIONS}from"../constants";/**
 * Request product relations action.
 * @param {Object} params Params.
 * @param {string} params.hash Query hash.
 * @returns {Object}
 */export default(function(_ref){var hash=_ref.hash;return{type:REQUEST_PRODUCT_RELATIONS,hash:hash};});